import { useEffect } from "react"
import { createDraftId } from "authoring/routes/project/lib/project-utils"
import { DraftTokensChanged } from "../schedule-editor-event-definitions.mjs"
import { registerScheduleEditorSession, unregisterScheduleEditorSession } from "../lib/schedule-editor-session"

/**
 * Registers the editor session ref for descendant hooks. Also raises DraftTokensChanged
 * when token ids change so macro-guidance subscribers can refresh locally.
 */
export function useScheduleEditorSession({ projectId, scheduleId, sessionRef, draftTokenIdsKey }) {
    const draftId = createDraftId(projectId, scheduleId)

    if (draftId && sessionRef) {
        registerScheduleEditorSession(draftId, sessionRef)
    }

    useEffect(unregisterSession, [draftId])
    useEffect(notifyDraftTokensChanged, [draftId, draftTokenIdsKey])

    function unregisterSession() {
        return () => unregisterScheduleEditorSession(draftId)
    }

    function notifyDraftTokensChanged() {
        if (!draftId || !draftTokenIdsKey) return
        DraftTokensChanged(draftId).raise()
    }
}
